/* MJD favorites. Guests: saved in this browser. Signed in: synced to Supabase (keyed to the
   Shopify customer ID and checked with the signature from snippets/mjd-fav-config.liquid). */
(function () {
  var C = window.MJDFAV || {}, KEY = 'mjd-favs', remote = !!(C.cid && C.sig);
  function readLocal() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function writeLocal(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var favs = readLocal();

  function rpc(fn, body) {
    return fetch(C.api + fn, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: C.key, Authorization: 'Bearer ' + C.key },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.status === 204 ? null : r.json(); });
  }

  function paint() {
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = favs.indexOf(b.dataset.fav) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (n) { n.textContent = favs.length || ''; n.hidden = !favs.length; });
  }

  function set(handle, on) {
    var i = favs.indexOf(handle);
    if (on && i < 0) favs.unshift(handle);
    if (!on && i > -1) favs.splice(i, 1);
    writeLocal(favs); paint();
    document.dispatchEvent(new CustomEvent('mjd:favs', { detail: favs.slice() }));
    if (remote) rpc('mjd_fav_set', { cid: C.cid, sig: C.sig, handles: [handle], on_: on }).catch(function () {});
    toKlaviyo(handle, on);
  }

  /* Klaviyo: "Favorited Product" / "Unfavorited Product" events plus a "Favorite Canvases" profile list.
     Klaviyo only ties these to a person once it knows who they are (logged in, or clicked through an email). */
  var details = {};
  function product(h) { if (!details[h]) details[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return details[h]; }
  function toKlaviyo(handle, on) {
    var k = window.klaviyo = window.klaviyo || [];
    product(handle).then(function (p) {
      var props = { Handle: handle, URL: location.origin + '/products/' + handle };
      if (p) {
        props.ProductName = p.title; props.ProductID = p.id; props.Price = p.price / 100;
        props.ImageURL = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        props.Available = p.available; props.Tags = p.tags; props.ProductType = p.type;
      }
      k.push(['track', on ? 'Favorited Product' : 'Unfavorited Product', props]);
      k.push(['identify', { 'Favorite Canvases': favs.slice(), 'Favorite Count': favs.length }]);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = favs.indexOf(b.dataset.fav) < 0;
    set(b.dataset.fav, on);
    if (on) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
  });

  window.MJDFavs = { list: function () { return favs.slice(); }, set: set, ready: null };

  /* signed in: fold this browser's hearts into the account, then use the account's list */
  window.MJDFavs.ready = (remote
    ? (favs.length ? rpc('mjd_fav_set', { cid: C.cid, sig: C.sig, handles: favs, on_: true }) : Promise.resolve())
        .then(function () { return rpc('mjd_fav_list', { cid: C.cid, sig: C.sig }); })
        .then(function (list) { if (Array.isArray(list)) { favs = list; writeLocal(favs); } })
        .catch(function () {})
    : Promise.resolve()
  ).then(function () { paint(); document.dispatchEvent(new CustomEvent('mjd:favs', { detail: favs.slice() })); return favs.slice(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  /* cards added later (load more, filters, sliders) */
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 60); }).observe(document.documentElement, { childList: true, subtree: true });
})();
